export const menu = state => state.menu
export const user = state => state.user
export const totalLogs = state => state.totalLogs
export const Logs = state => state.Logs
